import { useFormik } from "formik";
import React from "react";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import api from "../../api/auth_api";
import { SVG } from "../../assets/SVG/SVG";
import * as slides from "../../component/Carousel/CarousalSlides";
import Carousel from "../../component/Carousel/Carousel";
import { Button, CustomInput } from "../../component/common";
import { useAuth } from "../../utils/UseContext";

const SignIn: React.FC = () => {
  const [errorMsg, setErrorMessage] = React.useState("");
  const navigate = useNavigate();
  const { login } = useAuth();

  const formik = useFormik({
    initialValues: { username: "", password: "" },
    validationSchema: Yup.object({
      username: Yup.string()
        .required("Username is required")
        .email("Invalid username"),
      password: Yup.string().required("Password is required"),
    }),
    validateOnBlur: true,
    onSubmit: async (values) => {
      setErrorMessage("");
      const res = await api.signIn(
        values.username.toLowerCase(),
        values.password
      );
      if (res.data.success === true) {
        localStorage.clear();
        localStorage.setItem("token", res.data.token);
        localStorage.setItem("user_email", values.username.toLowerCase());
        localStorage.setItem("role", res.data.role);
        localStorage.setItem("user_password", values.password);
        localStorage.setItem("user__details", JSON.stringify(res.data.org));
        localStorage.setItem("user_id", res.data.org.user_id);
        login();
      } else {
        setErrorMessage(res.data.msg);
      }
    },
  });

  return (
    <div className=" flex  justify-center items-center max-h-screen">
      <div className=" flex justify-center items-center   h-screen lg:w-1/2">
        <div className="w-3/6 flex flex-col gap-2" >
          <SVG.LogoDark />
          <p className="text-xl mt-4 font-semibold" >{"Welcome Back!"}</p>
          <p className="text-xs text-gray-400 mb-4">
            {"Let's get you logged in."}
          </p>
          {errorMsg !== "" && (
            <div className="error text-center ">{errorMsg}</div>
          )}
          <form onSubmit={formik.handleSubmit} autoComplete="off">
            <div className="mb-2">
              <CustomInput
                type="text"
                name="username"
                label="Username"
                value={formik.values.username}
                onChange={formik.handleChange}
                isError={!!formik.touched.username && !!formik.errors.username}
                errorMessage={formik.errors.username}
              />
            </div>
            <div className="mb-2">
              <div className="relative container mx-auto">
                <CustomInput
                  type="password"
                  label="password"
                  value={formik.values.password}
                  onChange={formik.handleChange}
                  name="password"
                  isError={!!formik.touched.password && !!formik.errors.password}
                  errorMessage={formik.errors.password}
                />
              </div>
            </div>
            <div className="mb-4 text-button-primary">
              <div
                onClick={() => navigate("/forgot_password")}
                className="hover:underline text-xs"
              >
                Forgot Password?
              </div>
            </div>
            <Button
              type="submit"
              text={"Sign In"}
              className="w-full py-2.5 "
            />
          </form>
          <div className="mt-2">
            <span className="text-input-label">Don't have an account yet?</span>
            <span
              onClick={() => navigate("/signup")}
              className="hover:underline text-button-primary pl-2"
            >
              Sign Up
            </span>
          </div>
        </div>

      </div>
      <div className="w-1/2 h-screen hidden lg:flex lg:justify-center lg:items-center  ">
        <div className="onboard-box">
          <Carousel slides={slides.slides} />
        </div>
      </div>
    </div>
  );
};

export default SignIn;
